import React from 'react';
import Icon from 'components/Icon';


function CloseButton(props) {
	const {
		showButton,
		tapEvent,
	} = props;

	if (showButton) {
		return (
			<button role="button" className="CloseButton" onClick={tapEvent}>
				<div className="icon">
					<Icon category="ui" name={'close'} />
				</div>
			</button>
		);
	}
	return null;
}

export default CloseButton;
